<template>
  <div class="bg-color--blue-5">
    <div v-if="data.length" class="col-sm-12 col-lg-8 mx-auto bg-color--blue-5 p-5">
      <div class="container">
        <h2 class="mt-0 mb-3">Vanliga frågor</h2>
        <div id="accordion">
          <div v-for="(item, index) in data" :key="index" class="card">
            <div :id="'accordion' + index" class="card-header">
              <button
                :aria-controls="'accordion_' + index" :data-target="'#accordion_' + index" aria-expanded="true"
                class="btn btn-link collapsed" data-toggle="collapse">
                {{ item.title }}
                <span class="fa fa-plus"></span>
                <span class="fas fa-minus"></span>
              </button>
            </div>

            <div :id="'accordion_' + index" :aria-labelledby="'accordion' + index" :data-parent="'#accordion' + index"
                 class="collapse">                
                <div class="card-body col-md-10" v-html="item.content"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script lang="ts">
import { defineComponent, reactive } from "vue";


export default defineComponent({
  name: "Accordion",
  components: {},
  props: {
    data: {}
  },

  setup(props) {
    const state = reactive({});

    const data = [
      {
        title: "Vilka organisationer kan registrera sig?",
            content: "Alla med ett organisationsnummer, till exempel kommuner, regioner, fristående skolhuvudmän, bolag. "
      },
      {
          title: "Vi vill köpa licens till flera förvaltningar i vår kommun. Hur gör vi då?",
          content: "Kontakta oss så hjälper vi er att registrera era förvaltningar. "
       },     
      {
          title: "Måste jag registrera min organisation för att köpa licens till Digitala samlingen?",
          content: "Ja, ni måste registrera organisationen för att sedan kunna teckna PUB-avtal. Det behöver ni göra för att kunna köpa en licens.  "
      },
      {
        title: "Vem kan vara huvudkontakt?",
          content: "Den som registrerar organisationen ska ha rätt att företräda organisationen och blir er huvudkontakt. SPSM kommer att behöva godkänna registreringen efter att ni skickat in den. "
      },
      {
          title: "Kan jag som huvudkontakt lägga till andra administratörer? ",
          content: "Ja, du kan lägga till flera organisationsadministratörer när registreringen av organisationen är godkänd och klar. De tillagda organisationsadministratörerna kommer också kunna teckna PUB-avtal och köpa licens till Digitala samlingen.  "
      },
      {
          title: "Måste jag teckna PUB-avtal direkt vid registrering av organisationen?",
          content: "Nej, du kan registrera organisationen först och vid ett senare tillfälle teckna PUB-avtal. "
      },
        {
            title: "Var kan jag ta del av PUB-avtalet innan jag påbörjar registreringen?",
            content: "I webbutiken kan du läsa mer om vårt PUB-avtal och även ladda ner avtalet för påseende innan du påbörjar registreringen. <a href='https://webbutiken.spsm.se/kundservice/om-digitala-samlingen/pub-avtal/'>Läs mer om personuppgiftsbiträdesavtal i webbutiken</a>"
        },
      {
          title: "Kan man byta huvudkontakt?",
          content: "Ja, det kan ni göra om ni kontaktar oss. "
      }
    ];

    return {
      state,
      props,
      data
    };
  }
});

</script>

<style lang="scss" scoped>
#accordion {
  .btn {
    padding: 1.125rem 0;
    height: auto;

    &.collapsed {
      .fa-minus {
        display: none;
      }
    }

    &:not(.collapsed) {
      .fa-minus {
        display: inline-block;
      }

      .fa-plus {
        display: none;
      }
    }
  }
}
</style>